import { render, staticRenderFns } from "./flats-items.vue?vue&type=template&id=7486737a"
import script from "./flats-items.vue?vue&type=script&lang=js"
export * from "./flats-items.vue?vue&type=script&lang=js"
import style0 from "./flats-items.vue?vue&type=style&index=0&id=7486737a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports